module.exports = __webpack_public_path__ + "static/in-the-plex-179a8735a281ac4142feacc09514fbe2.jpg";